document.addEventListener('DOMContentLoaded', function () {

  /* =====================
     PRODUCTS DROPDOWN MENU
     ===================== */
  const menuButton = document.querySelector('.menubutton');
  const menuDropdown = document.querySelector('.menudropdown');

  if (menuButton && menuDropdown) {
    menuButton.addEventListener('click', function (e) {
      e.stopPropagation();
      menuDropdown.classList.toggle('active');
      const rect = menuButton.getBoundingClientRect();
      const parentRect = menuButton.parentElement.getBoundingClientRect();
      menuDropdown.style.left = (rect.left - parentRect.left) + 'px';
    });

    document.addEventListener('click', function () {
      menuDropdown.classList.remove('active');
    });
  }

  /* =====================
     MOBILE MENU
     ===================== */
  const hamburger = document.querySelector('.hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');
  const mobileMenuClose = document.querySelector('.mobile-menu-close');

  function openMobileMenu() {
    if (mobileMenu) { mobileMenu.classList.add('open'); document.body.style.overflow = 'hidden'; }
    if (hamburger) hamburger.classList.add('open');
  }

  function closeMobileMenu() {
    if (mobileMenu) { mobileMenu.classList.remove('open'); document.body.style.overflow = ''; }
    if (hamburger) hamburger.classList.remove('open');
  }

  if (hamburger) hamburger.addEventListener('click', openMobileMenu);
  if (mobileMenuOverlay) mobileMenuOverlay.addEventListener('click', closeMobileMenu);
  if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMobileMenu);

  /* =====================
     SMOOTH PRODUCT SCROLL
     ===================== */
  const scrollAreas = document.querySelectorAll('.sectionproducts');

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function animateScroll(element, target, duration) {
    const start = element.scrollLeft;
    const change = target - start;
    const startTime = performance.now();

    function step(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      element.scrollLeft = start + change * easeInOutCubic(progress);
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        element.dataset.isScrolling = 'false';
      }
    }
    requestAnimationFrame(step);
  }

  scrollAreas.forEach(function (area) {
    area.dataset.isScrolling = 'false';

    area.addEventListener('wheel', function (e) {
      if (area.scrollWidth <= area.clientWidth) return;
      e.preventDefault();
      if (area.dataset.isScrolling === 'true') return;

      const firstCard = area.querySelector('.sectionproduct');
      if (!firstCard) return;

      const styles = window.getComputedStyle(area);
      const gap = parseFloat(styles.columnGap || styles.gap || 0);
      const stepSize = firstCard.offsetWidth + gap;
      const currentIndex = Math.round(area.scrollLeft / stepSize);
      let targetIndex = currentIndex + (e.deltaY > 0 ? 1 : -1);
      const maxIndex = Math.max(0, Math.ceil((area.scrollWidth - area.clientWidth) / stepSize));
      targetIndex = Math.max(0, Math.min(targetIndex, maxIndex));

      area.dataset.isScrolling = 'true';
      animateScroll(area, targetIndex * stepSize, 550);
    }, { passive: false });
  });

  /* =====================
     PREDICTIVE SEARCH
     ===================== */
  const searchInput = document.getElementById('searchInput');
  const searchResults = document.getElementById('searchResults');

  if (searchInput && searchResults) {
    let debounceTimer;

    searchInput.addEventListener('focus', function () {
      if (searchInput.value.trim().length > 1) searchResults.classList.add('active');
    });

    searchInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      const q = searchInput.value.trim();
      if (q.length < 2) { searchResults.classList.remove('active'); return; }

      debounceTimer = setTimeout(async function () {
        try {
          const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`);
          const data = await res.json();
          const products = data.resources?.results?.products || [];

          if (!products.length) {
            searchResults.innerHTML = '<div class="searchresult" style="cursor:default"><div class="searchresultname">Inga produkter hittades</div></div>';
            searchResults.classList.add('active');
            return;
          }

          // Hämta fullständig produktdata parallellt för säker compare_at_price
          const fullProducts = await Promise.all(
            products.map(p =>
              fetch(`/products/${p.handle}.js`)
                .then(r => r.json())
                .catch(() => null)
            )
          );

          searchResults.innerHTML = products.map((p, i) => {
            const full = fullProducts[i];
            const variant = full?.variants?.[0];

            // Priser från produktens JSON är i ören (24900 = 249 kr)
            const priceCents = variant?.price ?? 0;
            const compareCents = variant?.compare_at_price ?? 0;
            const hasDiscount = compareCents > priceCents && compareCents > 0;
            const discount = hasDiscount
              ? Math.floor((compareCents - priceCents) / compareCents * 100)
              : 0;

            return `
              <a href="${p.url}" class="searchresult">
                <div class="searchresultimg"><img src="${p.featured_image?.url || ''}" alt="${p.title}"></div>
                <div class="searchresultname">${p.title}</div>
                <div class="searchresultprice">
                  ${formatSearchPrice(p.price)}
                  ${hasDiscount ? `<div class="searchresultpricebadge">-${discount}%</div>` : ''}
                </div>
              </a>
            `;
          }).join('');

          searchResults.classList.add('active');
        } catch {}
      }, 280);
    });

    document.addEventListener('click', function (e) {
      if (!searchInput.contains(e.target) && !searchResults.contains(e.target)) {
        searchResults.classList.remove('active');
      }
    });
  }

  // Cart API returnerar pris i ören (24900 = 249 kr)
  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' kr';
  }

  // Predictive Search API returnerar pris redan i kronor som sträng ("249.00")
  function formatSearchPrice(price) {
    return parseFloat(price).toFixed(2).replace('.', ',') + ' kr';
  }

  /* =====================
     ADD TO CART — .atc-btn
     ===================== */
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.atc-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    const originalText = btn.textContent.trim();
    btn.disabled = true;
    btn.textContent = '...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (res.ok) {
        btn.textContent = '✓';
        btn.style.background = '#2e7d32';
        updateCartCount();
        if (typeof window.showToast === 'function') {
          window.showToast(btn.dataset.productTitle || originalText);
        }
        setTimeout(() => {
          btn.textContent = originalText;
          btn.style.background = '';
          btn.disabled = false;
        }, 1800);
      } else {
        btn.textContent = 'Fel';
        setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2000);
      }
    } catch {
      btn.textContent = originalText;
      btn.disabled = false;
    }
  });

  /* =====================
     CART COUNT ON LOAD
     ===================== */
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const indicator = document.querySelector('.cartindicator');
      if (indicator) indicator.textContent = cart.item_count;
    } catch {}
  }
  updateCartCount();
});
